<template>
  <div class="accountSettings" :class="{ 'pa-5': xsOrsm, 'pa-6': breakpointMd, 'pa-4': xlOrlg }">
    <div class="accountSettings-body--title fw-600" :class="{ 'fs-18': breakpointXs, 'fs-25': !breakpointXs }">
      Account Settings
    </div>
    <div class="accountSettings-body--form pt-3">
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <TextField
              v-model="companyName"
              rules="required|max:50"
              :loading="isAccountSettingsFormLoading"
              label="Company Name"
              showIcons
              :showOnlyErrorIcons="true"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <TextField
              v-model="icegateId"
              rules="required|max:50"
              :loading="isAccountSettingsFormLoading"
              label="Icegate Id"
              showIcons
              :showOnlyErrorIcons="true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <TextField
              v-model="chaLicenceNo"
              :loading="isAccountSettingsFormLoading"
              rules="required|max:35"
              disabled
              showIcons
              :showOnlyErrorIcons="true"
              label="CHA Licence No"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <TextField
              v-model="chaAddress"
              :loading="isAccountSettingsFormLoading"
              rules="required|max:35"
              showIcons
              :showOnlyErrorIcons="true"
              label="CHA Address"
            />
          </v-col>
        </v-row>
        <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
          <v-btn
            width="140"
            color="button-primary"
            large
            class="white--text my-3"
            :loading="isAccountSettingsFormLoading"
            @click="passes(updateAccountSettings)"
          >
            <span class="font-weight-bold fs-15">Save</span>
          </v-btn>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import { SNACKBAR } from "@/store/actionTypes";
import * as AT from "@/modules/DashboardModule/store/actionTypes";
import { SET_ACCOUNT_STATE } from "@/modules/DashboardModule/store/mutationTypes";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "AccountSettings",
  components: {
    ValidationObserver,
    TextField
  },
  data() {
    return {
      companyName: "",
      icegateId: "",
      chaLicenceNo: "",
      chaAddress: "",
      isAccountSettingsFormLoading: false
    };
  },
  mounted() {
    this.getAccountDetails();
  },
  mixins: [commonMethodsMixin],
  methods: {
    getAccountDetails() {
      this.$store
        .dispatch(AT.GET_ACCOUNT_DETAILS)
        .then(res => {
          if (res) {
            this.companyName = res.company_name;
            this.icegateId = res.icegate_id;
            this.chaLicenceNo = res.cha_license_number;
            this.chaAddress = res.cha_address;
            this.$store.commit(SET_ACCOUNT_STATE, res);
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isAccountSettingsFormLoading = false;
        });
    },
    updateAccountSettings() {
      this.isAccountSettingsFormLoading = true;
      const formData = {
        company_name: this.companyName,
        icegate_id: this.icegateId,
        cha_address: this.chaAddress
      };
      this.$store
        .dispatch(AT.UPDATE_ACCOUNT_SETTINGS, formData)
        .then(res => {
          if (res && res.data) {
            this.$store.dispatch(SNACKBAR, {
              color: "success",
              text: "Account Details updated"
            });
          }
        })
        .catch(err => {
          this.handleError(err);
        })
        .finally(() => {
          this.isAccountSettingsFormLoading = false;
        });
    }
  }
};
</script>
